// components/HeroCarousel.jsx
import React, { useState } from "react";
import "./HeroCarousel.css";
import { useNavigate } from "react-router-dom";

import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";

function HeroCarousel() {
  const [videoReady, setVideoReady] = useState(false);
  const navigate = useNavigate();

  const handleSignup = () => {
    navigate("/signup");
  };

  return (
    <section className="hero-full-section" id="hero">
      {/* Background Layer */}
      <div className="hero-bg-layer">
        {/* VIDEO */}
        {/* <div className="hero-bg hero-bg--video hero-bg-overlay-dark">
          <video
            className="hero-bg-video"
            src="/Makkah.mp4"
            autoPlay
            muted
            loop
            playsInline
            onCanPlay={() => setVideoReady(true)}
          />
        </div> */}

        {/* COVER IMAGE (visible until video is ready) */}
        <div className={`hero-cover ${videoReady ? "" : ""}`}>
          <img
            src="/hero-zaman.png"
            alt="Kaaba cover"
            className="hero-cover-img"
          />
        </div>
      </div>

      <div className="hero-full-inner">
        <div className="hero-full-content-wrapper">
          <div className="hero-full-content slide-in-right">
            {/* <p className="hero-kicker">Digital Companion for Hajj &amp; Umrah</p> */}

            <h1 className="hero-main-title">
              Peace of Mind on Your Sacred Journey
            </h1>

            <p className="hero-main-body">
              Tawaf is your trusted digital companion for Hajj &amp; Umrah,
              offering voice-led guidance in your language every step of the
              way, so you can travel safely and confidently with your heart on
              worship.
            </p>

            {/* CTAs */}
            <div className="hero-main-actions">
              <button
                className="btn-primary hero-main-cta hero-main-cta-strong"
                onClick={handleSignup}
              >
                Join Now
                <ArrowForwardRoundedIcon fontSize="small" />
              </button>

              {/* <button
                className="btn-secondary hero-main-cta-secondary"
                onClick={() => navigate("/login")}
              >
                See how Tawaf works
              </button> */}
            </div>

            {/* Meta badge only (kept, but side card removed) */}
            {/* <div className="hero-meta-row">
              <div className="hero-meta-badge">
                <CheckCircleRoundedIcon className="hero-meta-icon" />
                <span>
                  Designed for families, elders &amp; first-time pilgrims
                </span>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroCarousel;
